import { AppService, Types as AppTypes } from '../../App/Services/AppService';
import { StaticDataExportedTypes } from './StaticDataExportedTypes';
// Symbols specific to this module.
const StaticDataTypes = {...AppTypes,
    Services: {
        ...StaticDataExportedTypes.Services,
    }
}
// Merged symbols from app for convenience.
const Types = {
    ...AppTypes,
    StaticData: StaticDataTypes
}
export { AppService, Types, StaticDataTypes }